import {CollectionViewer, DataSource} from '@angular/cdk/collections';
import {TableType11} from '../../_models';
import {Data} from '../../_providers';
import {Observable, BehaviorSubject} from 'rxjs';


export class Type11DataSource implements DataSource<TableType11> {
  // {
  // driver:'',
  // defect: 'OK\FAIL\N/A',
  // rtd: 'OK\FAIL\N/A',
  // tachograph: 'OK\FAIL\N/A',
  // comments:''
  // },

  filter = '';
  sortDirection = 'asc';
  pageIndex = 0;
  pageSize = 7;
  private tableData: any;
  private tableDisplayData = new BehaviorSubject<TableType11[]>([]);

  public constructor(private data: Data, private tableID: number) {
    this.tableData = data.getTableById(tableID); /// TODO maybe data validation
    if (Object.keys(this.tableData.table_data).length === 0) {
      this.tableData.table_data = [];
    }
    if (this.tableData.table_data.length < 10) {
      for (let i = this.tableData.table_data.length; i < 10; i++) {
        const tempObj: any = {};
        tempObj.driver = '';
        tempObj.defect = '';
        tempObj.rtd = '';
        tempObj.tachograph = '';
        tempObj.comments = '';
        this.tableData.table_data.push(tempObj);
      }
    }
  }

  dataLength() {
    return this.tableData.table_data.length;
  }

  connect(collectionViewer: CollectionViewer): Observable<TableType11[]> {
    return this.tableDisplayData.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.tableDisplayData.complete();
  }

  loadData(filter = this.filter, sortDirection = this.sortDirection, pageIndex = this.pageIndex, pageSize = this.pageSize) {
    this.filter = filter;
    this.sortDirection = sortDirection;
    this.pageIndex = pageIndex;
    this.pageSize = pageSize;


    const tempData: TableType11[] = [];
    for (let i = pageIndex * pageSize;
      i < this.tableData.table_data.length && i < (pageIndex + 1) * pageSize;
      i++) {
      const tempObj: any = {};
      tempObj.id = i;
      tempObj.driver = this.tableData.table_data[i].driver;
      tempObj.defect = this.tableData.table_data[i].defect;
      tempObj.rtd = this.tableData.table_data[i].rtd;
      tempObj.tachograph = this.tableData.table_data[i].tachograph;
      tempObj.comments = this.tableData.table_data[i].comments;

      tempData.push(tempObj);
    }

    this.tableDisplayData.next(tempData);
  }


  updateDriver(index: number, driver: string) {
    this.tableData.table_data[index].driver = driver;
    this.data.pushTableUpdate(this.tableData.id);
  }

  updateDefect(index: number, defect: string) {
    this.tableData.table_data[index].defect = defect;
    this.data.pushTableUpdate(this.tableData.id);
  }

  updateRTD(index: number, rtd: string) {
    this.tableData.table_data[index].rtd = rtd;
    this.data.pushTableUpdate(this.tableData.id);
  }

  updateTachograph(index: number, tachograph: string) {
    this.tableData.table_data[index].tachograph = tachograph;
    // this.loadData();//attempted as a quick fix for the form to show number dont work TODO look into turning the form red, with form
    // control
    this.data.pushTableUpdate(this.tableData.id);
  }

  updateComments(index: number, comments: string) {
    this.tableData.table_data[index].comments = comments;
    this.data.pushTableUpdate(this.tableData.id);
    // this.loadData();
  }


}
